
import Component from "vue-class-component";
import Vue from "vue";
import {
    AddPilotagePracticeRequest,
    factory,
    PracticesClient,
    PilotagePracticeActions,
    PilotagePracticeDetailsModel,
    IAddPilotagePracticeRequest
} from "@/api-client";
import PilotagePracticeUpsertForm from "@/features/documents/practices/components/PilotagePracticeUpsertForm.vue";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";
import {Prop} from "vue-property-decorator";
import {NavigationGuardNext} from "vue-router/types/router";
import {Location} from "vue-router";

interface Props {
    seafarerId: string;
    actions: PilotagePracticeActions;
    existingPractice: PilotagePracticeDetailsModel;
}

@Component({
    components: {
        FormLayout,
        PilotagePracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditPilotagePractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        const practiceId = to.params.id;
        Promise.all([
            new PracticesClient().availablePilotageActions(),
            new PracticesClient().getPilotagePractice(practiceId),
        ]).then(values => {
            props.actions = values[0];
            props.existingPractice = values[1];
            next();
        }).catch(e => next(e))
    }
})
export default class EditPilotagePractice extends Vue implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: PilotagePracticeActions;

    @Prop({required: true})
    existingPractice!: PilotagePracticeDetailsModel;

    @Prop({default: null})
    returnRoute!: Location | null;

    model: AddPilotagePracticeRequest = factory.create(AddPilotagePracticeRequest);

    isCreated = false;

    created() {
        this.model = new AddPilotagePracticeRequest({
            ...this.existingPractice,
            existingFiles: this.existingPractice.files || [],
            addedFiles: [],
            removedFiles: []
        } as IAddPilotagePracticeRequest);
        this.isCreated = true;
    }

    async submit(model: AddPilotagePracticeRequest, saveAndAddNew?: boolean): Promise<void> {
        const practiceId = this.$route.params.id;
        await new PracticesClient().edit(model, this.seafarerId, practiceId);

        if (saveAndAddNew) {
            // Navigate to Add view with cloned data
            await this.$router.push({
                name: "seafarer-add-pilotage-practice",
                params: {
                    seafarerId: this.seafarerId,
                },
                query: {
                    cloneFrom: practiceId
                }
            });
        } else {
            // Normal navigation after save
            const route = (this.returnRoute ? this.returnRoute : { name: "seafarer-practices" }) as Location;
            route.params = { seafarerId: this.seafarerId};
            this.$router.replace(route);
            // await this.$router.push({
            //     name: "seafarer-practices",
            //     params: {
            //         seafarerId: this.seafarerId,
            //     }
            // });
        }
    }
}
